import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const REQUEST_IMPORT_FROM_ARGOS = 'REQUEST_IMPORT_FROM_ARGOS';
export const SUCCESS_IMPORT_FROM_ARGOS = 'SUCCESS_IMPORT_FROM_ARGOS';
export const FAIL_IMPORT_FROM_ARGOS = 'FAIL_IMPORT_FROM_ARGOS';

export const REQUEST_EXPORT_USER_CARDS = 'REQUEST_EXPORT_USER_CARDS';
export const SUCCESS_EXPORT_USER_CARDS = 'SUCCESS_EXPORT_USER_CARDS';
export const FAIL_EXPORT_USER_CARDS = 'FAIL_EXPORT_USER_CARDS';

export const SHOW_USER_CARDS_EXPORT_INFO = 'SHOW_USER_CARDS_EXPORT_INFO';
export const HIDE_USER_CARDS_EXPORT_INFO = 'HIDE_USER_CARDS_EXPORT_INFO';

const importFromArgosRequest = () => ({ type: REQUEST_IMPORT_FROM_ARGOS });
const importFromArgosRequestSuccess = (error) => ({ type: SUCCESS_IMPORT_FROM_ARGOS, error });
const importFromArgosRequestFail = (error) => ({ type: FAIL_IMPORT_FROM_ARGOS, error });

const exportUserCardsRequest = () => ({ type: REQUEST_EXPORT_USER_CARDS });
const exportUserCardsRequestSuccess = (error) => ({ type: SUCCESS_EXPORT_USER_CARDS, error });
const exportUserCardsRequestFail = (error) => ({ type: FAIL_EXPORT_USER_CARDS, error });

const showUserCardsExportInfo = (list) => ({ type: SHOW_USER_CARDS_EXPORT_INFO, list });
export const hideUserCardsExportInfo = () => ({ type: HIDE_USER_CARDS_EXPORT_INFO });

export const importFromArgos = ({ period, location, dbOnly }) => (dispatch) => {
  dispatch(importFromArgosRequest());
  return communicate({ url: `Imports/ImportEvents?period=${period}&location=${location}&dbOnly=${dbOnly}` })
    .then((response) => {
      dispatch(importFromArgosRequestSuccess());
      toastrSuccess(response);
    }).catch((err) => {
      dispatch(importFromArgosRequestFail(err));
      toastrError(err);
    });
};

export const exportUserCards = () => (dispatch) => {
  dispatch(exportUserCardsRequest());
  return communicate({ url: 'Exports/ArgosCards', method: 'post' })
    .then(({ data }) => {
      dispatch(exportUserCardsRequestSuccess());
      if (data.ResultId > 0) {
        dispatch(showUserCardsExportInfo(data.Data));
      }
      toastrSuccess(data);
    }).catch((err) => {
      dispatch(exportUserCardsRequestFail(err));
      toastrError(err);
    });
};
